import { DateTime } from 'luxon';
import type { WeeklyOccurrenceFormType } from './WeeklyOccurrenceForm';

export const toPayload = (formData: WeeklyOccurrenceFormType) => {
  return {
    lottery: {
      occurrence: {
        occurrenceType: 'WEEKLY',
        startDate: formData.startDate,
        endDate: DateTime.fromISO(formData.startDate)
          .plus({ days: formData.numberOfWeeks * 7 - 1 })
          .toISODate(),
      },
      drawDay: formData.drawDay,
      drawTime: formData.drawTime,
    } as const,
  };
};
